export default __webpack_public_path__ + "static/media/warehouse.0db374fc.png";